import { render } from "./PaneLineSample.vue?vue&type=template&id=765bff25&scoped=true&ts=true"
import script from "./PaneLineSample.vue?vue&type=script&lang=ts"
export * from "./PaneLineSample.vue?vue&type=script&lang=ts"

import "./PaneLineSample.vue?vue&type=style&index=0&id=765bff25&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-765bff25"]])

export default __exports__